import { PAGE_REGISTRY } from '../content/pages';
import { MarketingContentPage } from './MarketingContentPage';
import { buildForCreatorsPageSchema } from '../lib/schema';

export { ForFilmmakersPage } from './ForFilmmakersPage';
export { ForAgenciesPage } from './ForAgenciesPage';
export { ForEnterprisePage } from './ForEnterprisePage';

function getPageEntry(path: string) {
  const entry = PAGE_REGISTRY.find((p) => p.path === path);
  if (!entry?.content) throw new Error(`Missing content for ${path}`);
  return { meta: entry.meta, content: entry.content, relatedLinks: entry.relatedLinks };
}

export function ForCreatorsPage() {
  const { meta, content, relatedLinks } = getPageEntry('/for-creators');
  return (
    <MarketingContentPage
      meta={meta}
      content={content}
      relatedLinks={relatedLinks}
      jsonLd={buildForCreatorsPageSchema()}
    />
  );
}

export function ScriptToVideoPage() {
  const { meta, content, relatedLinks } = getPageEntry('/use-cases/script-to-video');
  return <MarketingContentPage meta={meta} content={content} relatedLinks={relatedLinks} />;
}

export { AiVideoContinuityPage } from './AiVideoContinuityPage';

export function AiPrevizPage() {
  const { meta, content, relatedLinks } = getPageEntry('/use-cases/ai-previz');
  return <MarketingContentPage meta={meta} content={content} relatedLinks={relatedLinks} />;
}
